import React, { useState } from "react";
import {
  Table,
  Tag,
  Space,
  Divider,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
} from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { error, warning, success } from "../../Controllers/toast";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Card, CardBody, CardHeader } from "reactstrap";
import findPlantId from "../../Controllers/findPlantId";
import { useSelector } from "react-redux";
const { Option } = Select;

const layout = {
  labelCol: {
    span: 9,
  },
  wrapperCol: {
    span: 15,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 24,
  },
};

const check_color = (role) => {
  switch (role) {
    case "editor":
      return "purple";
    case "reader":
      return "blue";
    default:
      return "lime";
  }
};

const ADD_USER = gql`
  mutation AddUserPlant(
    $email: String!
    $mobile: String!
    $role: String
    $plant_id: Int
  ) {
    AddUserPlant(
      email: $email
      mobile: $mobile
      role: $role
      plant_id: $plant_id
    ) {
      user_id
      firstname
      lastname
      email
      mobile
    }
  }
`;

const CHANGE_USER = gql`
  mutation ($role: String!, $plant_id: Int!, $user_id: Int!) {
    ChangePlantUser(role: $role, plant_id: $plant_id, user_id: $user_id) {
      email
      firstname
      lastname
      role
      user_id
    }
  }
`;
const DELETE_USER = gql`
  mutation ($plant_id: Int!, $user_id: Int!) {
    DeletePlantUser(plant_id: $plant_id, user_id: $user_id) {
      email
      firstname
      lastname
      role
      user_id
    }
  }
`;
const GET_USERS = gql`
  query ($plant_id: Int!) {
    GetPlantUsers(plant_id: $plant_id) {
      email
      firstname
      lastname
      role
      user_id
    }
  }
`;

const FactUser = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);

  const check_name = (role) => {
    switch (role) {
      case "editor":
        return lang_choiced.pages.fact_user.modal.forms.roles.selectors[0];
      case "reader":
        return lang_choiced.pages.fact_user.modal.forms.roles.selectors[1];
      default:
        return lang_choiced.pages.fact_user.modal.forms.roles.selectors[1];
    }
  };
  // const add_fact = useSelector((state) => state.add_fact_step3);
  // const dispatch = useDispatch();

  const columns = [
    {
      title: lang_choiced.pages.fact_user.table.first_name,
      dataIndex: "firstname",
      key: "firstname",
      render: (text) => <a>{text}</a>,
    },
    {
      title: lang_choiced.pages.fact_user.table.last_name,
      dataIndex: "lastname",
      key: "lastname",
    },

    {
      title: lang_choiced.pages.fact_user.table.role,
      key: "role",
      dataIndex: "role",
      render: (role, row, index) => {
        let color = check_color(role);
        let name = check_name(role);

        return (
          <Tag color={color} key={index}>
            {name}
          </Tag>
        );
      },
    },
    {
      title:  lang_choiced.pages.fact_user.table.actions.title,
      key: "action",
      render: (text, record, index) => {
        // console.log();
        return (
          <>
            {data.filter(
              (r) => r.email === window.localStorage.getItem("email")
            )[0].role === "editor" ? (
              <Space size="middle">
                <a
                  onClick={() => {
                    Modal.warning({
                      width: "60%",
                      title:  lang_choiced.pages.fact_user.table.actions.changeModal.title,
                      content: (
                        <Modal_Content
                          change={true}
                          index={index}
                          role={record.role}
                        />
                      ),
                      okType: "danger",
                      okText: "بازگشت",
                    });
                  }}
                >
                  {lang_choiced.pages.fact_user.table.actions.btnChange}
                </a>

                <Divider type="vertical" />
                <a
                  onClick={() => {
                    Modal.error({
                      title: lang_choiced.pages.fact_user.table.actions.changeModal.userDelete.title,
                      content: lang_choiced.pages.fact_user.table.actions.changeModal.userDelete.description,
                      okType: "danger",
                      okText: lang_choiced.pages.fact_user.table.actions.changeModal.userDelete.btnRemove,
                      cancelText: lang_choiced.pages.fact_user.table.actions.changeModal.userDelete.btnClose,
                      okCancel: true,
                      onOk() {
                        deleteUser({
                          variables: { plant_id, user_id: record.user_id },
                        });
                        // setData(
                        //   data.filter((data) => data.email !== record.email)
                        // );
                      },
                    });
                  }}
                >
                  {lang_choiced.pages.fact_user.table.actions.btnRemove}
                </a>
              </Space>
            ) : (
              ""
            )}
          </>
        );
      },
    },
  ];

  const [data, setData] = useState();
  const [role, setRole] = useState();
  const plant_id = parseInt(findPlantId());

  const { loading: GetUsersLoading } = useQuery(GET_USERS, {
    variables: {
      plant_id,
    },
    onCompleted: (res) => {
      // console.log(res.GetPlantUsers);
      setData(res.GetPlantUsers);
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!");
    },
  });

  const [addUser, { loading }] = useMutation(ADD_USER, {
    onCompleted: (res) => {
      // console.log(res);
      if (res.AddUserPlant.user_id !== null) {
        // console.log([...data, { ...res.CheckUserExist, role }]);
        setData([...data, { ...res.AddUserPlant, role }]);
        Modal.destroyAll();
        success("کاربر با موفقیت اضافه شد !");
      } else {
        error("کاربری با این مشخصات یافت نشد!");
      }
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!");
    },
  });

  const [changeUser] = useMutation(CHANGE_USER, {
    onCompleted: (res) => {
      setData(res.ChangePlantUser);
      warning("!اطلاعات با موفقیت تغییر یافت");
    },
    onError: (err) => {
      error("مشکلی رخ داده است!");
      // console.log(err);
    },
  });

  const [deleteUser] = useMutation(DELETE_USER, {
    onCompleted: (res) => {
      setData(res.DeletePlantUser);
      warning("!کاربر با موفقیت حذف شد ");
    },
    onError: (err) => {
      error("مشکلی رخ داده است!");
      // console.log(err);
    },
  });

  const Modal_Content = ({ text, change, index, role }) => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);

    const handleFinish = (value) => {
      let { email, mobile, role } = value;
      mobile = mobile.replace(0, 98);
      setRole(role);
      addUser({ variables: { email, mobile, role, plant_id } });
      form.resetFields();
    };

    const onFinish = (value) => {
      if (change !== true) {
        if (data.length === 0) {
          // console.log(data, value);

          handleFinish(value);
        } else {
          const repeatiousUser = data.filter(
            (user) => user.email === value.email
          );
          const repeatiousUser2 = data.filter(
            (user) => user.mobile === value.mobile
          );

          if (repeatiousUser.length > 0 || repeatiousUser2.length > 0) {
            error("! اطلاعات وارد شده تکراری است ");
          } else {
            // console.log(data, value);
            // if(visible === true){
            handleFinish(value);
            // }
          }
        }
      } else {
        const { user_id } = data[index];
        changeUser({ variables: { user_id, role: value.role, plant_id } });
        form.resetFields();
        Modal.destroyAll();
      }
    };
    const onFinishFailed = (err) => {
      console.warn(err);
    };
    const toggleCheckBox = (value) => {
      setVisible(value.target.checked);
    };
    if (change !== true) {
      return (
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          // initialValues={{ checked: false, contractor: false }}
        >
          {
            <Form.Item
              {...tailLayout}
              name="role"
              key="role"
              label={
                <span>
                  <TeamOutlined className="Icon-style" />{" "}
                  {lang_choiced.pages.fact_user.modal.forms.roles.title}{" "}
                </span>
              }
              rules={[{ required: true, message: "لطفا نقش را وارد کنید !" }]}
            >
              <Select hasFeedback className="login-form-style ">
                <Option value="editor">
                  {lang_choiced.pages.fact_user.modal.forms.roles.selectors[0]}
                </Option>
                <Option value="reader">
                  {lang_choiced.pages.fact_user.modal.forms.roles.selectors[1]}
                </Option>
              </Select>
            </Form.Item>
          }

          <React.Fragment>
            <Form.Item
              name="email"
              key="email"
              label={
                <span>
                  <TeamOutlined className="Icon-style" />{" "}
                  {lang_choiced.pages.fact_user.modal.forms.email}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "لطفا پست الکترونیکی را وارد کنید !",
                },
                {
                  type: "email",
                  message: "لطفا ایمیل خود را به درستی وارد کنید !",
                },
              ]}
            >
              <Input
                className="login-form-style input-ltr"
                style={{ direction: "ltr !important" }}
              />
            </Form.Item>
            <Form.Item
              name="mobile"
              key="mobile"
              label={
                <span>
                  <TeamOutlined className="Icon-style" />{" "}
                  {lang_choiced.pages.fact_user.modal.forms.mobile}
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "لطفا شماره موبایل را وارد کنید !",
                },

                {
                  pattern: /[0-9]\d{8,}/g,
                  message: "لطفا شماره موبایل را به درستی وارد کنید!",
                },
              ]}
            >
              <Input
                className="login-form-style input-ltr"
                style={{ direction: "ltr !important" }}
              />
            </Form.Item>
          </React.Fragment>

          <Form.Item {...tailLayout} className="text-center">
            <Button type="primary" htmlType="submit">
              {lang_choiced.pages.fact_user.modal.btnAccept}
            </Button>
          </Form.Item>
        </Form>
      );
    } else {
      return (
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ checked: false, contractor: false, role }}
        >
          <Form.Item
            {...tailLayout}
            name="role"
            key="role"
            label={
              <span>
                <TeamOutlined className="Icon-style" />{" "}
                {
                  lang_choiced.pages.fact_user.table.actions.changeModal
                    .roleChange.title
                }{" "}
              </span>
            }
            rules={[{ required: true, message: "لطفا نقش را وارد کنید !" }]}
          >
            <Select hasFeedback className="login-form-style ">
              <Option value="editor">
                {
                  lang_choiced.pages.fact_user.table.actions.changeModal
                    .roleChange.selectors[0]
                }
              </Option>
              <Option value="reader">
                {
                  lang_choiced.pages.fact_user.table.actions.changeModal
                    .roleChange.selectors[1]
                }
              </Option>
            </Select>
          </Form.Item>
          <Form.Item {...tailLayout} className="text-center">
            <Button type="primary" htmlType="submit">
              {
                lang_choiced.pages.fact_user.table.actions.changeModal
                  .roleChange.btnAccept
              }
            </Button>
          </Form.Item>
        </Form>
      );
    }
  };

  return (
    <Card>
      <CardHeader>
        <h3>{lang_choiced.pages.fact_user.title}</h3>
      </CardHeader>
      {/* <ToastContainer /> */}
      <CardBody>
        <Button
          className="mb-3"
          type="primary"
          onClick={() => {
            Modal.info({
              width: "60%",
              title: lang_choiced.pages.fact_user.modal.title,
              content: <Modal_Content text="!کاربر با موفقیت اضافه شد" />,
              okType: "danger",
              okText: lang_choiced.pages.fact_user.modal.btnClose,
            });
          }}
        >
          {lang_choiced.pages.fact_user.btnAddUser}
        </Button>
        <Table
          columns={columns}
          dataSource={data}
          loading={GetUsersLoading}
          rowKey={(record) => record.email}
        />
      </CardBody>
    </Card>
  );
};

export default FactUser;
